import { ToggleGroup, ToggleGroupItem } from '~components/ui/toggle-group';
import type { PlannedOrActual } from '../context';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */

type PlannedOrActualSelectProps = {
  /** Currently selected coordinate type */
  selected: PlannedOrActual;
  /** Callback when a different coordinate type is selected */
  onChange: (selected: PlannedOrActual) => void;
};

/* -------------------------------------------------------------------------- */
/*                               Main component                               */
/* -------------------------------------------------------------------------- */

/**
 * Toggle group for selecting between planned and actual coordinates.
 * Uses single selection mode.
 *
 * @example
 * ```tsx
 * const [coordType, setCoordType] = useState<PlannedOrActual>('planned');
 *
 * <PlannedOrActualSelect selected={coordType} onChange={setCoordType} />
 * ```
 */
const PlannedOrActualSelect = ({ selected, onChange }: PlannedOrActualSelectProps) => {
  const handleValueChange = (v: string) => {
    if (v) {
      onChange(v as PlannedOrActual);
    }
  };

  return (
    <ToggleGroup type="single" variant="outline" size="lg" block value={selected} onValueChange={handleValueChange}>
      <ToggleGroupItem value="planned">Planned X/Y</ToggleGroupItem>
      <ToggleGroupItem value="actual">Actual X/Y</ToggleGroupItem>
    </ToggleGroup>
  );
};

/* -------------------------------------------------------------------------- */
/*                                   Exports                                  */
/* -------------------------------------------------------------------------- */

export { PlannedOrActualSelect };
